export default "__VITE_ASSET__BDcMWzDb__"